import type { LogoType } from '../../types';

export const sponsors: LogoType[] = [
  {
    id: 'c1b058a9',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo4.png',
        name: 'logo4.png',
        alt: '',
        width: 318,
        height: 299
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'f7495d57',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo6.png',
        name: 'logo6.png',
        alt: '',
        width: 300,
        height: 237
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'cec620fc',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        name: 'logo8.png',
        alt: '',
        width: 300,
        height: 300
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '202b5134',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo9.png',
        name: 'logo9.png',
        alt: '',
        width: 300,
        height: 171
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '7cb85ed3',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        name: 'logo14.png',
        alt: '',
        width: 300,
        height: 140
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '87bca5e4',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo15.png',
        name: 'logo15.png',
        alt: '',
        width: 299,
        height: 105
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '68feb485',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo16.png',
        name: 'logo16.png',
        alt: '',
        width: 299,
        height: 156
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
